import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  addProposalService,
  getProposalsByJobService,
  getProposalService,
  patchProposalsService,
  putProposalsService
} from '../../services/proposal';
import * as type from '../ActionTypes';
import { getJobByIdService } from '../../services/jobs';
import { clientProfileDataByIdService } from '../../services/clientProfileData';
import { getCoderByIdService } from '../../services/profile/coder.service';
import { getErrorMszOnFailure } from '../../helper/utils';
import { postMilestoneRecordService } from '../../services/timesheet';

function* addProposal(action: any): any {
  try {
    const proposal = yield call(addProposalService, action.payload);
    if (proposal.statusCode === 201) {
      yield put({
        type: type.ADD_JOB_PROPOSAL_SUCCESS,
        proposal: proposal.data
      });
    } else {
      yield put({
        type: type.ADD_JOB_PROPOSAL_FAILURE,
        message: proposal.data.job_post[0] ?? 'Something went wrong'
      });
    }
  } catch (e: any) {
    yield put({ type: type.ADD_JOB_PROPOSAL_FAILURE, message: e.message });
    console.warn(e.message);
  }
}

function* getProposalByJob(action: any): any {
  try {
    const proposals = yield call(getProposalsByJobService, action.params);
    const proposalCoderUser =
      proposals?.data?.results?.length > 0
        ? yield all(
            proposals?.data?.results?.map((user: any) => call(getCoderByIdService, user.user))
          )
        : [];
    const proposalData = proposals?.data?.results?.map((item: any, index: number) => ({
      ...item,
      hourly_rate: parseInt(item.hourly_rate),
      ...proposalCoderUser[index]
    }));

    yield put({
      type: type.GET_PROPOSAL_BY_JOB_SUCCESS,
      proposal: proposalData,
      proposalCount: proposals?.data?.count,
      proposalTotalPages: proposals?.data?.total_pages
    });
  } catch (e: any) {
    yield put({ type: type.ADD_JOB_PROPOSAL_FAILURE, message: e.message });
    console.warn(e.message);
  }
}
function* getClientInfoByJobPostInProposalRequest(action: any): any {
  try {
    const proposal = yield call(getProposalsByJobService, action.params);
    if (proposal?.data?.results && proposal?.data?.results.length > 0) {
      const jobPostData = yield all(
        proposal.data?.results.map((o: any) => call(getJobByIdService, o.job_post))
      );
      const clientData = yield all(
        jobPostData.map((o: any) => call(clientProfileDataByIdService, o.data.user))
      );

      if (
        proposal.statusCode === 200 &&
        jobPostData.length > 0 &&
        jobPostData[0].status === 200 &&
        clientData.length > 0 &&
        clientData[0].status === 200
      ) {
        const jobPostDataArr = jobPostData.map((o: any) => o.data);
        const clientDataArr = clientData.map((o: any) => o.data);

        const jobPost_clientData = jobPostDataArr.map((o: any, i: any) => ({
          ...o,
          proposalId: proposal?.data?.results[i].id,
          proposalStatus: proposal?.data?.results[i].status,
          clientData: clientDataArr.filter((cd: any) => cd.id == o.user)[0]
        }));

        yield put({
          type: type.GET_PROPOSAL_BY_JOB_SUCCESS,
          proposal: { ...proposal?.data, results: jobPost_clientData }
        });
      } else {
        yield put({
          type: type.GET_PROPOSAL_BY_JOB_SUCCESS,
          proposal: {}
        });
      }
    } else {
      yield put({
        type: type.GET_PROPOSAL_BY_JOB_SUCCESS,
        proposal: {}
      });
    }
  } catch (e: any) {
    yield put({ type: type.ADD_JOB_PROPOSAL_FAILURE, message: e.message });
    console.warn(e.message);
  }
}

function* getProposal(action: any): any {
  try {
    const proposal = yield call(getProposalService, action.proposalId);
    yield put({
      type: type.GET_PROPOSAL_SUCCESS,
      proposal: proposal.data
    });
  } catch (e: any) {
    yield put({ type: type.ADD_JOB_PROPOSAL_FAILURE, message: e.message });
    console.warn(e.message);
  }
}

function* getProposalDataByFilter(action: any): any {
  try {
    const proposal = yield call(getProposalsByJobService, action.params);
    if (proposal?.data && proposal.data?.results.length > 0) {
      yield put({
        type: type.GET_PROPOSAL_SUCCESS,
        proposal: proposal.data?.results.length > 0 ? proposal.data?.results[0] : {}
      });
    }
  } catch (e: any) {
    yield put({ type: type.ADD_JOB_PROPOSAL_FAILURE, message: e.message });
    console.warn(e.message);
  }
}

function* putProposalRecord(action: any): any {
  try {
    const proposal = yield call(putProposalsService, action.params.data, action.params.id);
    if (proposal.status === 200) {
      yield put({
        type: type.GET_PROPOSAL_SUCCESS,
        proposal: proposal.data
      });
    } else {
      yield put({
        type: type.PUT_PROPOSAL_FAILURE,
        error: getErrorMszOnFailure(proposal?.data) ?? 'Something went wrong'
      });
    }
  } catch (e: any) {
    yield put({
      type: type.ADD_JOB_PROPOSAL_FAILURE,
      message: e?.message ?? 'Something went wrong'
    });
    console.warn(e.message);
  }
}

function* patchProposalRecord(action: any): any {
  try {
    const proposal = yield call(patchProposalsService, action.params.data, action.params.id);
    if (proposal.status === 200) {
      yield put({
        type: type.GET_PROPOSAL_SUCCESS,
        proposal: proposal.data
      });
    } else {
      yield put({
        type: type.PUT_PROPOSAL_FAILURE,
        error: 'Something went wrong'
      });
    }
  } catch (e: any) {
    yield put({ type: type.ADD_JOB_PROPOSAL_FAILURE, message: e.message });
    console.warn(e.message);
  }
}

function* getProposalListByJob(action: any): any {
  try {
    const proposals = yield call(getProposalsByJobService, action.params);
    const proposalData = yield all(
      proposals.data.results.map((o: any) => call(getCoderByIdService, o.user))
    );
    const coders_with_proposals = yield proposalData.map((o: any) => o.data);
    const coderResults = yield coders_with_proposals.map((coder: any) => ({
      ...coder,
      proposalData: proposals.data.results.find((cd: any) => cd.user === coder.id)
    }));
    yield put({
      type: type.GET_PROPOSAL_LIST_BY_JOB_SUCCESS,
      proposal: coderResults
    });
  } catch (e: any) {
    yield put({ type: type.GET_PROPOSAL_LIST_BY_JOB_FAILURE, error: e.message });
  }
}
function* submitFixedProposal(action: any): any {
  try {
    const milestone = yield call(postMilestoneRecordService, {
      ...action.payload.milestones[0],
      job_post: action.payload.job_post
    });
    const mileStoneArr = action.payload.milestones.filter((o: any, i: any) => i > 0);
    if (milestone?.data?.job_proposal) {
      const milestoneArrResponse = yield all(
        mileStoneArr.map((o: any, i: any) =>
          call(postMilestoneRecordService, {
            ...o,
            job_post: action.payload.job_post,
            job_proposal: milestone?.data?.job_proposal
          })
        )
      );
      const milestoneArrResponseSuccess = milestoneArrResponse.every((o: any) => o.status === 201);
      const pdata = {
        id: milestone?.data?.job_proposal,
        proposal_description: action.payload?.proposalDetail,
        attachment_1:
          action.payload.proposalFiles?.length > 0 ? action.payload.proposalFiles?.[0] : null,
        attachment_2:
          action.payload.proposalFiles?.length > 0 ? action.payload.proposalFiles?.[1] : null,
        attachment_3:
          action.payload.proposalFiles?.length > 0 ? action.payload.proposalFiles?.[2] : null,
        is_submitted: false,
        status: 'SENT'
      };
      const patchData = {
        is_submitted: true
      };

      const putSuccess = yield call(putProposalsService, pdata, milestone?.data?.job_proposal);
      const patchSuccess = yield call(
        patchProposalsService,
        patchData,
        milestone?.data?.job_proposal
      );
      if (
        milestone.status === 201 &&
        milestoneArrResponseSuccess &&
        putSuccess.status === 200 &&
        patchSuccess.status === 200
      ) {
        yield put({
          type: type.SUBMIT_FIXED_PROPOSAL_SUCCESS,
          proposal: action.payload
        });
      } else {
        yield put({
          type: type.SUBMIT_FIXED_PROPOSAL_FAILURE,
          error: 'Something went wrong',
          proposal: action.payload
        });
      }
    }
  } catch (e: any) {
    yield put({ type: type.ADD_JOB_PROPOSAL_FAILURE, message: e.message });
    console.warn(e.message);
  }
}

function* getProposalForClientDashboard(action: any): any {
  try {
    const proposal = yield call(getProposalsByJobService, action.params);
    const proposalData = proposal.data.results;
    const jobPostData = yield all(
      proposalData.map((o: any) => call(getJobByIdService, o.job_post))
    );
    if (proposal.statusCode === 200 && jobPostData.length > 0) {
      const jobPostDataArr = jobPostData.map((o: any) => o.data);
      const jobPost_clientData = jobPostDataArr.map((o: any) => ({
        ...o,
        proposalData: proposalData.find((el: any) => el.job_post === o.id)
      }));
      yield put({
        type: type.GET_PROPOSAL_RECEIVED_SUCCESS,
        payload: {
          results: jobPost_clientData,
          total_pages: proposal.data.total_pages,
          count: proposal.data.count
        }
      });
    } else {
      yield put({
        type: type.GET_PROPOSAL_RECEIVED_FAILURE,
        message: 'Oops, something went wrong!'
      });
    }
  } catch (e: any) {
    yield put({ type: type.GET_PROPOSAL_RECEIVED_FAILURE, message: 'Oops, something went wrong!' });
    console.warn(e.message);
  }
}

function* proposalSaga() {
  yield takeEvery(type.ADD_JOB_PROPOSAL_REQUEST, addProposal);
  yield takeLatest(type.GET_PROPOSAL_BY_JOB_REQUEST, getProposalByJob);
  yield takeEvery(type.GET_PROPOSAL_LIST_BY_JOB_REQUEST, getProposalListByJob);
  yield takeEvery(
    type.GET_PROPOSAL_CLIENTINFO_BY_JOBPOST_REQUEST,
    getClientInfoByJobPostInProposalRequest
  );
  yield takeEvery(type.GET_PROPOSAL_REQUEST, getProposal);
  yield takeEvery(type.PUT_PROPOSAL_REQUEST, putProposalRecord);
  yield takeEvery(type.PATCH_PROPOSAL_REQUEST, patchProposalRecord);
  yield takeEvery(type.SUBMIT_FIXED_PROPOSAL_REQUEST, submitFixedProposal);
  yield takeEvery(type.GET_PROPOSAL_RECEIVED_REQUEST, getProposalForClientDashboard);
  yield takeEvery(type.GET_PROPOSAL_BY_FILTER_REQUEST, getProposalDataByFilter);
}

export default proposalSaga;
